import { IFacilitiesStore } from './index'

export default {
  facilities: [],
  facilitiesObject: {},
} as IFacilitiesStore
